<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Promotion Factor Information</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader class="queryLabel">{{labels.productQuery}}</v-subheader>
              <div class="title">{{promoFactForm.product}}</div>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="promoFactForm.fact1">
                  <v-subheader class="queryLabel">{{labels.fact1}}</v-subheader>
                  <div class="title">{{promoFactForm.fact1}}</div>
                </v-flex>
                <v-flex xs4 v-if="promoFactForm.fact2">
                  <v-subheader class="queryLabel">{{labels.fact2}}</v-subheader>
                  <div class="title">{{promoFactForm.fact2}}</div>
                </v-flex>
                <v-flex xs4 v-if="promoFactForm.fact3">
                  <v-subheader class="queryLabel">{{labels.fact3}}</v-subheader>
                  <div class="title">{{promoFactForm.fact3}}</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="promoFactForm.fact4">
                  <v-subheader class="queryLabel">{{labels.fact4}}</v-subheader>
                  <div class="title">{{promoFactForm.fact4}}</div>
                </v-flex>
                <v-flex xs4 v-if="promoFactForm.fact5">
                  <v-subheader class="queryLabel">{{labels.fact5}}</v-subheader>
                  <div class="title">{{promoFactForm.fact5}}</div>
                </v-flex>
                <v-flex xs4 v-if="promoFactForm.fact6">
                  <v-subheader class="queryLabel">{{labels.fact6}}</v-subheader>
                  <div class="title">{{promoFactForm.fact6}}</div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <promotion-rates v-if="!newPromoFact" :promoRates="promoRates" :promoFacts="factorForm"></promotion-rates>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import PromotionRates from './PromotionRates'
import { PROMOTION_PROMOFACT } from '@/store/types'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      labels: {
        productType: 'Product Type*',
        product: 'Product*',
        productQuery: 'Product',
        fact1: 'Factor 1',
        fact2: 'Factor 2',
        fact3: 'Factor 3',
        fact4: 'Factor 4',
        fact5: 'Factor 5',
        fact6: 'Factor 6'
      },
      promoFactForm: {
        promotion: undefined,
        product: undefined,
        fact1: undefined,
        fact2: undefined,
        fact3: undefined,
        fact4: undefined,
        fact5: undefined,
        fact6: undefined,
        revision: undefined
      },
      appID: undefined,
      productLoading: false,
      productList: [],
      menu: [],
      newPromoFact: false,
      submitting: false,
      promoRates: []
    }
  },
  computed: {
    appIDList() {
      return this.$store.state.promotionManagement.promotion.appIDList
    },
    factorList() {
      return this.$store.state.promotionManagement.promotion.factorList
    },
    factorForm() {
      const result = {
        fact1: this.promoFactForm.fact1,
        fact2: this.promoFactForm.fact2,
        fact3: this.promoFactForm.fact3,
        fact4: this.promoFactForm.fact4,
        fact5: this.promoFactForm.fact5,
        fact6: this.promoFactForm.fact6
      }
      return result
    }
  },
  methods: {
    async doInit() {
      if (!this.newPromoFact) {
        this.promoFactForm.product = this.product
        // Review
        await this.queryPromoFact()
        this.queryPromotionRates()
      }
    },
    async queryPromoFact() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionFactorGet
      if (apiURI) {
        try {
          const expand = {
            promotion: this.promotion,
            product: this.promoFactForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Promotion Factor init
            this.promoFactForm.promotion = data.promoFact.promotion
            this.promoFactForm.product = data.promoFact.product
            this.promoFactForm.fact1 = data.promoFact.fact1
            this.promoFactForm.fact2 = data.promoFact.fact2
            this.promoFactForm.fact3 = data.promoFact.fact3
            this.promoFactForm.fact4 = data.promoFact.fact4
            this.promoFactForm.fact5 = data.promoFact.fact5
            this.promoFactForm.fact6 = data.promoFact.fact6
            this.promoFactForm.revision = data.promoFact.revision

            const promoFactors = {
              fact1: this.promoFactForm.fact1,
              fact2: this.promoFactForm.fact2,
              fact3: this.promoFactForm.fact3,
              fact4: this.promoFactForm.fact4,
              fact5: this.promoFactForm.fact5,
              fact6: this.promoFactForm.fact6
            }
            this.$store.commit(PROMOTION_PROMOFACT, promoFactors)
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async queryPromotionRates() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionRates
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promoFactForm.promotion,
            product: this.promoFactForm.product
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.promoRates = []
              data.map((promotionRate) => {
                const convertPromotionRate = {
                  promotion: promotionRate.promotion,
                  product: promotionRate.product,
                  commGN: promotionRate.commGN,
                  commPct: promotionRate.commPct,
                  discPct: promotionRate.discPct,
                  fact1: this.formatDisplayNumber(promotionRate.fact1),
                  fact2: this.formatDisplayNumber(promotionRate.fact2),
                  fact3: this.formatDisplayNumber(promotionRate.fact3),
                  fact4: this.formatDisplayNumber(promotionRate.fact4),
                  fact5: this.formatDisplayNumber(promotionRate.fact5),
                  fact6: this.formatDisplayNumber(promotionRate.fact6),
                  protComm: this.formatBoolean(promotionRate.protComm),
                  protDisc: this.formatBoolean(promotionRate.protDisc),
                  revision: promotionRate.revision
                }
                this.promoRates.push(convertPromotionRate)
              })
            } else {
              this.promoRates = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    }
  },
  created() {
    this.doInit()
  },
  props: {
    promotion: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    PromotionRates
  }
}
</script>

<style lang="scss">

</style>
